import Text from 'components/elements/texts/Text'
import React from 'react'
import styled from 'styled-components'

/**
 * SJ用グローバルフッター・全ての画面に適用するフッター
 */

const SjGlobalFooter: React.FC = () => {
  return (
    <React.Fragment>
      <SjAreaSpace />
      <SjArea>
        <SjFooterText>Copyright©2014-2021</SjFooterText>
        <SjFooterText>Sompo Japan Insurance Inc.</SjFooterText>
        <SjFooterText>All Rights Reserved.</SjFooterText>
      </SjArea>
    </React.Fragment>
  )
}

const SjAreaSpace = styled.div`
  height: 70px;
`

const SjArea = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 70px;
  background: var(--color-main);
`

const SjFooterText = styled(Text)`
  color: var(--color-text-for-main-background);
  font-size: 12px;
  text-align: center;
`

export default SjGlobalFooter
